import React, { FC } from 'react';
import styled from 'styled-components';

import { WithChildren } from '@investown/fe/common-utils';

import { FormSizeName } from 'styles/theme';

interface Props extends WithChildren {
  className?: string;
  width?: FormSizeName;
}

const FormLayout: FC<Props> = ({ children, className, width }) => (
  <FormContainer className={className} width={width}>
    {children}
  </FormContainer>
);

const FormContainer = styled.div<{ width?: FormSizeName }>`
  display: flex;
  flex-direction: column;
  max-width: ${({ theme, width }) => (width ? theme.form[width as FormSizeName] : theme.form.narrow)};
  width: 100%;
  margin: auto;

  .ant-form-item {
    margin: 0 0 ${({ theme }) => theme.margins.small} 0;

    @media screen and (max-width: ${({ theme }) => theme.form.wide}) {
      &:last-child {
        .ant-form-item-control-wrapper {
          margin-left: 0;
        }
      }
    }
  }
  .ant-form-item-control-wrapper {
    width: 100%;
  }
`;

export default FormLayout;
